import Animation from '../animations/animation';
const tools = require('../tools');

class AnimEngine {
    constructor() {
        this.animations = [];
        this.uniques = [];
        this.stock = {};
        this.run = false;
        this.loops = 0;
        this.print = false;
        // this.startEngine();
        this.images = {};
        this.perf = {};
        this.measurePerf();
    }

    isHightPerf() {
        return this.perf.ratio ? this.perf.ratio < 20 : true;
    }

    startEngine() {
        if(!this.run) {
            this.run = true;
            if(this.print) {
                console.log("started");
                console.log(this.animations);
            }

            let animate = () => {
                if(this.run) {
                    window.requestAnimationFrame(animate);

                    let top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                    top = top < 0 ? 0 : top;
                    let onCounter = 0;
                    for (let i = 0; i < this.animations.length; i++) {
                        let animation = this.animations[i];
                        if(animation.iterate(top)){
                            onCounter++;
                        }
                    }

                    // if(this.loops % 100 === 0) {
                    //     this.drainUniques();
                    // }
                    this.loops++;

                    if(this.print) {
                        console.log(this.loops);
                    }
                    if(onCounter === 0) {
                        this.stopEngine();
                    }
                }
            };

            animate();
        }
    }
    measurePerf() {
        let name = 'perf';
        let param = {count: 0, date: 0, mseconds: 500, dateMax: 1};
        let func = (anim) => {
            if(anim.date === 0) {
                anim.date = Date.now();
                anim.dateMax = anim.date + anim.mseconds;
            }

            if(Date.now() >= anim.dateMax) {
                anim.switchOff(anim2 => {
                    let realTime = Date.now() - anim2.date;
                    anim2.elem.perf = {
                        time: anim.mseconds,
                        realTime: realTime,
                        iteration: anim.count,
                        ratio: anim.count /realTime * 1000 ,
                    };

                    if(anim2.elem.print) {
                        console.log(anim2.elem.perf);
                        if(anim2.elem.perf.ratio > 55) {
                            document.body.style.backgroundColor = "green";
                        } else if(anim2.elem.perf.ratio > 45) {
                            document.body.style.backgroundColor = "yellow";
                        } else if(anim2.elem.perf.ratio > 35) {
                            document.body.style.backgroundColor = "orange";
                        } else if(anim2.elem.perf.ratio > 25) {
                            document.body.style.backgroundColor = "red";
                        } else  {
                            document.body.style.backgroundColor = "black";
                        }
                    }
                })
            }
        };

        this.createAnimation(name, this, func, param);
    }
    addAnimation(animation, unique=false) {
        if(this.checkIn(animation, unique)) {
            this.animations.push(animation);
            this.startEngine();
        }
    }

    addAnimations(animations) {
        animations.reduce((a,b)=>{
            if(this.checkIn(b)) {
                this.animations.push(b);
            }
        }, null);

        this.startEngine();
    }

    createAnimation(name, elem, func, param=null, delay=0, on=true, unique=false) {
        if(name !== null && elem !== null && func !== null) {
           let anim = new Animation(name, elem, func, param, delay, on);
            if(this.checkIn(anim, unique)) {
                this.animations.push(anim);
            }
            this.startEngine();
        }
    }

    checkIn(animation, unique=false) {
        if(animation !== null && animation.iterate) {
            if(unique) {
                if (this.uniques.indexOf(animation.name) === -1) {
                    this.uniques.push(animation.name);
                    return true;
                } else {
                    this.stock[animation.name] = animation;
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    stopEngine() {
        this.run = false;
        if(this.print) {
            console.log("stoped");
        }
        this.animations = [];
        setTimeout(()=>{this.drainUniques();}, 700);

    }

    drainUniques() {
        if(this.uniques.length > 0) {
            if(this.print){
                console.group('drain uniques')
            }
            for (let i = 0; i < this.uniques.length; i++) {
                if(this.stock[this.uniques[i]]) {
                    if(this.print){
                        console.log(this.uniques[i]);
                    }
                    this.animations.push(this.stock[this.uniques[i]]);
                }
            }
            if(this.print) {
                console.groupEnd()
            }
            this.stock = {};
            this.uniques = [];
            this.startEngine();
        }
    }

    loadImages() {

        let lazyImages = document.getElementsByClassName('lazy-img');
        let param = {range: window.innerHeight};
        if(lazyImages) {
            let func = (anim, top) => {
                if (anim.elem.offsetParent) {  //check if element visible. (elem.offsetParent === null if self or parents not visible (display none)
                    if (anim.elem.getBoundingClientRect().top <= anim.range) {

                        let imgSrc = anim.elem.getAttribute('data-src');
                        let image = this.images[imgSrc] | null;
                        if(image) {
                            anim.elem.classList.remove('lazy-img');
                            anim.elem.classList.remove('onepix');
                            anim.elem.src = image.src;
                        } else {
                            image = new Image();
                            image.onload = () => {
                                anim.elem.classList.remove('lazy-img');
                                anim.elem.classList.remove('onepix');
                                anim.elem.src = image.src;
                            };
                            image.src = imgSrc;
                            this.images[imgSrc] = image;
                        }
                        anim.switchOff();
                    }
                }
            };

            tools.each(lazyImages, (elt) => {
                this.createAnimation('lazyimgload', elt, func, param);
            });
        }

        let lazyBackgrounds = document.getElementsByClassName('lazy-bg');
        if(lazyBackgrounds) {
            tools.each(lazyBackgrounds, (elt) => {
                let func = (anim, top) => {
                    if (anim.elem.offsetParent) {  //check if element visible. (elem.offsetParent === null if self or parents not visible (display none)
                        if (anim.elem.getBoundingClientRect().top <= anim.range) {

                            let imgSrc = anim.elem.getAttribute('data-src');
                            let image = this.images[imgSrc] | null;
                            if(image) {
                                anim.elem.classList.remove('lazy-bg');
                                anim.elem.classList.remove('onepix');
                                anim.elem.style.backgroundImage = 'url("' + image.src + '")';
                            } else {
                                image = new Image();
                                image.onload = () => {
                                    anim.elem.classList.remove('lazy-bg');
                                    anim.elem.classList.remove('onepix');
                                    anim.elem.style.backgroundImage = 'url("' + image.src + '")';
                                };
                                image.src = imgSrc;
                                this.images[imgSrc] = image;
                            }
                            anim.switchOff();
                        }
                    }
                };

                this.createAnimation('lazybgload', elt, func, param);
            });
        }
    }
}

export default AnimEngine;
